<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";

  import Spacer from "@/components/spacer.svelte";
  import SubNav from "@/views/bandiburri/subnav.svelte";
  import { Route } from "svelte-router-spa";

  export let currentRoute;
  export let params;
</script>

<Route {currentRoute} {params} />
<SubNav {currentRoute} />

<Container>
  <div class="mainview">
    <div>
      <img src="/images/bandiburri/welcome/ceo.jpg" alt="인사말" />
    </div>
    <Row>
      <Col xs="12" md="5">
        <div class="intro1">
          <br />최고의 품질과 서비스로 새로운 산업을 이끌어나가는
          <span style="color: #874935; font-weight: 600;">
            혁신의 선두주자가 되기 위해 노력을 기울이겠습니다.
          </span>
        </div>
      </Col>

      <Col xs="12" md="7">
        <div class="intro2" style="word-break: keep-all;">
          <br />2002년 개인사업자 설립. 국내 '스마트팜' 이라는 단어조차 생소하던
          시절,
          <br />
          2008년에 재난방지 관제 시스템인 '엑스파크'를 개발함으로부터
          <br />
          시작이 되었습니다.<br /><br />새이 후 영상감지 장치제어, 축사/비닐
          하우스 원격제어관리 시스템 ‘반딧불이’ 출시 등 농가에 도움이 되는 여러
          시스템을 개발하였습니다.<br />
          <br />
          2013년에 법인전환을 하여 본격적으로 스마트팜의 대중화를 위해 정부와 협력,
          박람회 등 국내 농업발전에 도움이 되고자 하는 일들에 모두 앞장섰습니다.
          <br />
          <br />
          현재는 4차산업혁명의 도래에 맞추어 인공지능, 사물인터넷을 접목한 원격제어,
          관제, 클라우드 기반의 빅데이터 서비스가 가능한 시스템을 개발했습니다.
          <br />
          <br />
          아직 많이 부족하지만, 이런 농업데이터 기술개발은 여러분들의 도움이 많이
          필요합니다.
          <br />
          <br />
          반딧불이는 발전속도가 더뎠던 농업분야의 발전을 선도하며 새로운 산업혁명을
          개척하고 있습니다. 수출을 위한 국내 농산품 생산량 확보 문제, 제어시스템을
          통한 농업의 인건비 문제 등 국내의 많은 사회문제 및 공헌을 하기위해 노력하겠습니다.
          <br /><br />
          새로운 산업을 이끌어나가는 혁신의 선두주자가 되기위해 고객으로부터 지속적인
          사랑과 신뢰를 받을 수 있는 ㈜나래트랜드가 되겠습니다.
          <br />
          <br />
          감사합니다.
        </div>
      </Col>
    </Row>
    <Spacer size="3rem" />
  </div>
</Container>

<style lang="scss">
  .intro1 {
    font-size: 2rem;
  }
  .intro2 {
    font-size: 1.2rem;
    padding-left: 0px;
  }
  @media (min-width: 768px) {
    .intro1 {
      font-size: 1.5rem;
    }
    .intro2 {
      font-size: 1rem;
      padding-left: 4rem;
    }
  }
</style>
